import { Colors } from "@/enums/Colors";
import { ReplayOutlined } from "@mui/icons-material";
import { Box, Button, Dialog, DialogContent, Typography, styled } from "@mui/material";

const StyledButton = styled(Button)(({ theme }) => ({
  width: "158.5px",
  height: "44px",
  textTransform: "none",
  padding: 0,
  borderRadius: ".5rem",
  gap: "0.4rem",
  "&.close-button": {
    color: Colors.BUTTON_HOVER_PURPLE,
    backgroundColor: Colors.WHITE,
    border: `1px solid ${Colors.BUTTON_HOVER_PURPLE}`,
  },
  "&.undo-button": {
    color: Colors.WHITE,
    backgroundColor: Colors.BUTTON_HOVER_PURPLE,
    "& .MuiSvgIcon-root": {
      rotate: "y 180deg",
      scale: "1.2",
    },
  },
}));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  position: "absolute",
  minHeight: "162px",
  "& .MuiPaper-root": {
    "& .MuiDialogContent-root": {
      padding: "24px",
      overflow: "hidden",
    },
  },
}));

const Container = styled(Box)(({ theme }) => ({
  "&.content-container": {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  "&.button-container": {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    gap: "16px",
  },
}));

const Text = styled(Typography)(({ theme }) => ({
  "&.modal-title": {
    fontWeight: "bold",
    fontSize: "14px",
  },
  "&.modal-content": {
    fontSize: "12px",
    color: Colors.LIGHT_GRAY_8A8E93,
  },
}));

interface Props {
  showUndoDeleteModal: boolean;
  conversationTitle: string;
  handleOnClose: () => void;
  handleUndoDelete: () => void;
}

export const UndoDeleteConversationModal = ({ showUndoDeleteModal, conversationTitle, handleOnClose, handleUndoDelete }: Props) => {
  return (
    <StyledDialog
      hideBackdrop
      sx={{ pointerEvents: "none" }}
      PaperProps={{
        sx: {
          pointerEvents: "auto",
          boxShadow: `0 3px 8px ${Colors.STONE_GRAY}`,
          borderRadius: "1rem",
        },
      }}
      open={showUndoDeleteModal}
      onClose={handleOnClose}
    >
      <DialogContent>
        <Container className="content-container">
          <Text className="modal-title">Chat Deleted</Text>
          <Text className="modal-content">{`You deleted "${conversationTitle}"`}</Text>
          <Container className="button-container">
            <StyledButton className="close-button" onClick={handleOnClose}>
              Close
            </StyledButton>
            <StyledButton className="undo-button" onClick={handleUndoDelete}>
              <ReplayOutlined />
              <Typography>Undo</Typography>
            </StyledButton>
          </Container>
        </Container>
      </DialogContent>
    </StyledDialog>
  );
};
